export default "__VITE_ASSET__BujMixA___"